import { EventsType } from 'components/Events/types'
import escapeHtml from 'escape-html'
import { IGraphDataPoint } from 'screens/UserDetails/Graph/types'
import { colorMap } from './colorMap'

const getEventDetail = (event: EventsType): string | null => {
  const typename = event.__typename

  if (typename === 'Meal') {
    const score = event.mealStatistics?.glucoseScore
    return score == null ? null : `Score: ${score}`
  }

  if (typename === 'Measurement') {
    const { value, units } = event
    return `${value} ${units}`
  }

  if (typename === 'Activity') {
    const { description } = event
    return description.split(':')[0]
  }

  return null
}

const renderEventRow = (event: EventsType): string => {
  const detail = getEventDetail(event)
  const detailIsLong = Boolean(detail && detail.length > 16)
  const marker = `<span style="display:block;flex:0 0 auto;width:8px;height:8px;border-radius:50%;background:${colorMap(
    event.__typename
  )};"></span>`
  const title = `<span style="font-weight:bold;font-size:12px;white-space:nowrap;">${escapeHtml(
    event.title || event.__typename || ''
  )}</span>`
  const detailNode = detail
    ? `<span style="display:block;font-size:12px;line-height:1.4;white-space:normal;text-align:${
        detailIsLong ? 'left' : 'right'
      };min-width:0;overflow-wrap:break-word;">${escapeHtml(detail)}</span>`
    : ''

  return `<div style="display:flex;align-items:center;gap:8px;min-width:0;margin-top:4px;">${marker}<div style="display:grid;grid-template-columns:max-content minmax(0,1fr);column-gap:16px;align-items:center;width:100%;min-width:0;">${title}${detailNode}</div></div>`
}

// Builds the glucose-point tooltip markup for ECharts' HTML-string tooltip
// formatter: a header with the timestamp and reading, then one row per event.
export const getTooltipHtml = (
  point: IGraphDataPoint,
  units: string,
  formatTime: (time: number) => string
): string => {
  const header = `<div style="display:grid;grid-template-columns:minmax(0,1fr) auto;column-gap:24px;align-items:center;margin-bottom:6px;"><span style="font-weight:bold;font-size:14px;white-space:nowrap;">${escapeHtml(
    formatTime(point.time)
  )}</span><span style="font-weight:bold;font-size:14px;white-space:nowrap;text-align:right;">${escapeHtml(
    String(point.displayValue ?? point.value)
  )} ${escapeHtml(units)}</span></div>`

  const rows = (point.events ?? []).map(renderEventRow).join('')

  return `<div style="display:inline-block;min-width:220px;width:fit-content;max-width:calc(100vw - 24px);box-sizing:border-box;white-space:normal;padding:8px 12px;">${header}${rows}</div>`
}
